import { ComponentType } from '../component/component-types'

export enum ReportType {
    All = 0,
    OilAnalysis,
    VisualInspection,
    GeneratorStatusReport,
}

export const ReportTypes = [
    {
        labelKey: 'common.reportTypes.all',
        value: ReportType.All,
        componentTypes: [ComponentType.Transformer, ComponentType.Generator]
    },
    {
        labelKey: 'common.reportTypes.oilAnalysis',
        value: ReportType.OilAnalysis,
        componentTypes: [ComponentType.Transformer]
    },
    {
        labelKey: 'common.reportTypes.visualInspection',
        value: ReportType.VisualInspection,
        componentTypes: [ComponentType.Transformer]
    },
    {
        labelKey: 'common.reportTypes.generatorStatusReport',
        value: ReportType.GeneratorStatusReport,
        componentTypes: [ComponentType.Generator]
    },
] as const
